import { styled } from '@mui/material/styles';
import { TURN_STYLES } from '@/styles/theme';

export const Body = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: '0',
  right: '0',
  bottom: '0',
  left: '0',
  display: 'grid',
  placeItems: 'center',
  fontFamily: 'Inter, Roboto, Helvetica, Arial, sans-serif',
  backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkBackgroundColor : 'rgba(232, 237, 242, 1)',
}));

export const Container = styled('div')(({ theme }) => ({
  width: '600px',
  height: 'fit-content',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '75px 27px',
  backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkSurfaceColor : 'white',
  borderRadius: '16px',
  overflow: 'hidden',
}));

export const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '30px',
});

export const InformationContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const Title = styled('h1')({
  fontSize: '24px',
  lineHeight: '34px',
  textAlign: 'center',
  fontWeight: '700',
});

export const Text = styled('p')({
  maxWidth: '445px',
  margin: '0',
  marginBottom: '4px',
  fontSize: '14px',
  lineHeight: '18px',
  textAlign: 'center',
  color: TURN_STYLES.secondaryButtonColor,

  '&:nth-child(2)': {
    margin: '0',
  },
});

export const Link = styled('a')({
  color: TURN_STYLES.primaryAccentColor,
  textDecoration: 'underline',
  cursor: 'pointer',

  '&:hover': {
    textDecoration: 'none',
  },
});
